export default __webpack_public_path__ + "static/media/coin.d898537b.svg";